'use strict';

module.exports = function () {
    //get query params and remove the beginning '?'
    var query = window.location.search.substring(1);

    //split on ampersand
    var vars = query.split('&');

    var pairs = [];

    //loop through 'vars' array
    for (var i = 0; i < vars.length; i++) {
        // split on '=' to give key value pairs
        var pair = vars[i].split('=');

        pairs.push({
            key: pair[0],
            value: pair[1]
        });
    }

    return pairs;
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/utilities/get-all-query-vars.js
// module id = 186
// module chunks = 0